<template>
  <a :href="href" target="_blank">
    <img class="attribution-image" :src="src" :width="width" :height="height" :alt="alt" />
  </a>
</template>

<script>
import { attributionMap } from '@@/bits/web_search'
import ProcessedImage from '@@/vuecomponents/processed_image.vue'

export default {
  components: { ProcessedImage },
  props: {
    alt: {
      type: String,
      default: '',
    },
    provider: {
      type: String,
      required: true,
    },
  },
  computed: {
    href() {
      return attributionMap[this.provider].href
    },
    src() {
      return attributionMap[this.provider].src
    },
    width() {
      return attributionMap[this.provider].width
    },
    height() {
      return attributionMap[this.provider].height
    },
  },
}
</script>

<style lang="scss" scoped>
.attribution-image {
  display: block;
}
</style>
